import { FC, MouseEvent, useState } from "react";
import {
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import SyncIcon from "@mui/icons-material/Sync";

type UserListAdminMenuProps = {
  onAddDbUsersToCognito: () => void;
  onSyncCognitoAttributes: () => void;
};

export const UserListAdminMenu: FC<UserListAdminMenuProps> = ({
  onAddDbUsersToCognito,
  onSyncCognitoAttributes,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        aria-label="Admin user actions"
        onClick={handleOpen}
        color="primary"
        sx={{
          border: "1px solid",
          borderColor: "primary.main",
          width: 40,
          height: 40,
        }}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem
          onClick={() => {
            handleClose();
            onAddDbUsersToCognito();
          }}
        >
          <ListItemIcon>
            <GroupAddIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Add DB Users to Cognito</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            onSyncCognitoAttributes();
          }}
        >
          <ListItemIcon>
            <SyncIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Sync Cognito Custom Attributes</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};
